module.exports = __webpack_public_path__ + "static/media/Beryl Wu.2fe10ea5.png";